import mixPanelService from "./trackers/mixpanel"

const setup = (env: string): void => {
  mixPanelService.setup(env)
}

export default {
  setup
}
